/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Endpoint_Not_Found_BodyInputs */

const en_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We couldn’t find an endpoint for “${i?.path}”.`)
};

const zh_hans1_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`找不到“${i?.path}”对应的接口。`)
};

const pt_br2_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não encontramos um endpoint para “${i?.path}”.`)
};

const es_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No encontramos un endpoint para “${i?.path}”.`)
};

const fr_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous n’avons pas trouvé d’endpoint pour « ${i?.path} ».`)
};

const de_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben keinen Endpoint für „${i?.path}“ gefunden.`)
};

const ru_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы не нашли эндпоинт по запросу «${i?.path}».`)
};

const it_endpoint_not_found_body = /** @type {(inputs: Endpoint_Not_Found_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Non abbiamo trovato un endpoint per «${i?.path}».`)
};

/**
* | output |
* | --- |
* | "We couldn’t find an endpoint for “{path}”." |
*
* @param {Endpoint_Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_not_found_body = /** @type {((inputs: Endpoint_Not_Found_BodyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Not_Found_BodyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_not_found_body(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_not_found_body(inputs)
	if (locale === "es") return es_endpoint_not_found_body(inputs)
	if (locale === "fr") return fr_endpoint_not_found_body(inputs)
	if (locale === "de") return de_endpoint_not_found_body(inputs)
	if (locale === "ru") return ru_endpoint_not_found_body(inputs)
	if (locale === "it") return it_endpoint_not_found_body(inputs)
	return en_endpoint_not_found_body(inputs)
});